import { EventBus, EventType } from 'scbk-services/event-bus/bus/event-bus';

/**
 * 메뉴이동
 * @param menuId 메뉴ID
 * @param dom
 * @param json
 * @param callbackSuc
 * @param isClearStack
 * @param direction
 * @param callbackErr
 */
export function goMenu(
    menuId: string,
    dom?: unknown,
    json?: unknown,
    callbackSuc?: unknown,
    isClearStack?: unknown,
    direction?: unknown,
    callbackErr?: unknown,
) {
    console.log(
        `#call asis goMenu function menuId=${menuId}, dom=${dom}, json=${json}, 
        callbackSuc=${callbackSuc}, isClearStack=${isClearStack}, direction=${direction}, callbackErr=${callbackErr}`,
    );

    EventBus.getInstance().emit(EventType.MenuNavigationRequest, menuId, {
        routeData: { ...(json ?? {}) },
    });
}

/**
 * 화면 이동
 * @param url
 * @param dom
 * @param json
 * @param callbackSuc
 * @param isClearStack
 * @param direction
 * @param callbackErr
 * @param isSubmitCheck
 */
export function loadNextPage(
    url: string,
    dom?: unknown,
    json?: unknown,
    callbackSuc?: unknown,
    isClearStack?: unknown,
    direction?: unknown,
    callbackErr?: unknown,
    isSubmitCheck?: unknown,
) {
    console.log(
        `#call asis loadNextPage function 
        url=${url}, dom=${dom}, json=${json}, 
        callbackSuc=${callbackSuc}, isClearStack=${isClearStack}, direction=${direction}, 
        callbackErr=${callbackErr}. isSubmitCheck=${isSubmitCheck}`,
    );

    EventBus.getInstance().emit(EventType.UrlNavigationRequest, url);
}

/**
 *
 * @param url
 * @param dom
 * @param json
 * @param callbackSuc
 * @param callbackErr
 */
export function changeNextPage(
    url: string,
    dom?: unknown,
    json?: unknown,
    callbackSuc?: unknown,
    callbackErr?: unknown,
) {
    console.log(
        `#call asis changeNextPage function 
        url=${url}, dom=${dom}, json=${json}, 
        callbackSuc=${callbackSuc}, callbackErr=${callbackErr}`,
    );

    EventBus.getInstance().emit(EventType.UrlNavigationRequest, url);
}
